import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  close: {
    top: '24px',
    right: '24px'
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px',
    padding: '24px'
  },

  title: {
    marginBottom: '8px',
    fontSize: theme.size.lg,
    textAlign: 'center',
    color: '#3C425B'
  },

  text: {
    marginBottom: '8px',
    fontSize: theme.size.base,
    textAlign: 'center',
    color: '#3C425B',

    '& span': {}
  },

  buttonArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    margin: '16px -24px -24px -24px',
    height: '96px',
    paddingRight: '24px',
    background: '#F5F6F8',
    borderRadius: '0px 0px 8px 8px'
  },

  buttonAreaSub: {
    justifyContent: 'center',
    padding: '0',
    columnGap: '16px',

    '& button': {
      flex: '1',
      maxWidth: '200px'
    }
  },

  buttonAreaMobile: {
    position: 'absolute',
    bottom: '24px',
    left: '24px',
    right: '24px'
  },

  button: {
    height: '48px'
  }
}))

export default useStyles
